import { Icon, type IconName } from './Icon';
import { haptic } from '@/lib/telegram';

export type TabId = 'home' | 'setup' | 'account' | 'help';

interface Tab {
  id: TabId;
  icon: IconName;
  label: string;
}

const TABS: Tab[] = [
  { id: 'home', icon: 'home', label: 'главная' },
  { id: 'setup', icon: 'install', label: 'установка' },
  { id: 'account', icon: 'user', label: 'профиль' },
  { id: 'help', icon: 'headset', label: 'помощь' },
];

interface BottomTabsProps {
  active: TabId;
  onChange: (id: TabId) => void;
}

export function BottomTabs({ active, onChange }: BottomTabsProps) {
  return (
    <div
      style={{
        position: 'absolute',
        left: 12,
        right: 12,
        bottom: 18,
        background: 'rgba(20,19,15,0.94)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        borderRadius: 999,
        height: 60,
        display: 'flex',
        alignItems: 'center',
        padding: 6,
        boxShadow: '0 6px 24px rgba(20,19,15,0.18)',
        zIndex: 40,
      }}
    >
      {TABS.map((t) => {
        const isActive = active === t.id;
        return (
          <button
            key={t.id}
            onClick={() => {
              haptic('light');
              onChange(t.id);
            }}
            style={{
              appearance: 'none',
              border: 'none',
              cursor: 'pointer',
              flex: isActive ? '0 0 auto' : 1,
              height: 48,
              borderRadius: 999,
              background: isActive ? 'var(--paper)' : 'transparent',
              color: isActive ? 'var(--ink)' : 'rgba(244,240,232,0.55)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
              padding: isActive ? '0 18px' : '0',
              transition: 'all 200ms cubic-bezier(0.2, 0.8, 0.2, 1)',
              fontFamily: 'var(--f-body)',
              fontSize: 13,
              fontWeight: 500,
            }}
          >
            <Icon name={t.icon} size={20} stroke="currentColor" sw={1.7} />
            {isActive && <span>{t.label}</span>}
          </button>
        );
      })}
    </div>
  );
}
